import { render, staticRenderFns } from "./info-clientes.vue?vue&type=template&id=30b59bd3&"
import script from "./info-clientes.vue?vue&type=script&lang=js&"
export * from "./info-clientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports